import React, { Component } from 'react';
import { Modal, DatePicker, Select, Input, Form, message, Row, Col } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const FormItem = Form.Item;
const dateFormat = 'YYYY-MM-DD';

class CreateForm extends Component {
    state = {
        mistakeTypeList: []
    }

    componentDidMount() {
        this.queryAllPmMistakeType();
    }

    queryAllPmMistakeType = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryAllPmMistakeType,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { mistakeTypeList = [] } = res;
                this.setState({ mistakeTypeList });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { mistakeTypeList } = this.state;
        const { params = {}, form: { getFieldDecorator } } = this.props;
        const { userCompellation, employeeCode } = params;
        const formItemLayout = {
            labelCol: {
                sm: { span: 7 },
                md: { span: 7 },
            },
            wrapperCol: {
                sm: { span: 16, offset: 1 },
                md: { span: 16, offset: 1 },
            },
        };
        const mistakeTypeOption = mistakeTypeList.map(i => <Option key={i.pmMistakeTypeId}>{i.typeName}</Option>);
        return (
            <Form>
                <FormItem {...formItemLayout} label="人员">
                    {`${userCompellation}[${employeeCode}]`}
                </FormItem>
                <FormItem {...formItemLayout} label="工作失误发生时间">
                    {
                        getFieldDecorator('mistakeTime', {
                            rules: [{
                                required: true,
                                message: '请选择工作失误发生时间'
                            }],
                        })(
                            <DatePicker placeholder="请选择" style={{ width: 240 }} />
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="工作失误类型">
                    <Row style={{ lineHeight: '26px' }}>
                        <Col span={18}>
                            {
                                getFieldDecorator('mistakeTypeId', {
                                    rules: [{
                                        required: true,
                                        message: '请选择工作失误类型'
                                    }]
                                })(
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 240 }}
                                    >
                                        {mistakeTypeOption}
                                    </Select>
                                )
                            }
                        </Col>
                    </Row>
                </FormItem>
                <FormItem {...formItemLayout} label="工作失误具体描述">
                    <Row style={{ lineHeight: '26px' }}>
                        <Col span={18}>
                            {
                                getFieldDecorator('mistakeDescription', {
                                    rules: [{
                                        required: true,
                                        message: '请输入工作失误具体描述'
                                    }]
                                })(
                                    <Input style={{ width: 200 }} placeholder="请输入" />
                                )
                            }
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}

class UpdateWorkError extends Component {
    state = {
        params: {},
        visible: false,
        confirmLoading: false,
    }

    show = (parentRecord, record) => {
        const { userId, userCompellation, employeeCode } = parentRecord;
        const params = {
            userId,
            ...(record || {}),
            employeeCode,
            userCompellation,
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        });
    }

    hide = () => {
        this.setState({
            visible: false
        });
    }

    confirm = () => {
        this.formRef.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            const { mistakeTime } = values;
            const { isEdit, params } = this.state;
            const { userId, pmWorkMistakeId } = params;

            this.setState({ confirmLoading: true });
            const url = isEdit ? API_URL.user.editPmWorkMistake : API_URL.user.addPmWorkMistake;

            const options = {
                method: 'POST',
                url,
                data: {
                    ...values,
                    userId,
                    pmWorkMistakeId,
                    mistakeTime: moment(mistakeTime).format(dateFormat),
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.setState({ confirmLoading: false }, () => {
                        this.props.loadData(userId);
                    });
                },
                errorResult: () => {
                    this.setState({ confirmLoading: false });
                },
            }
            $.sendRequest(options);
        });
    }

    render() {
        const { isEdit, confirmLoading, visible, params } = this.state;
        const newProps = {};
        const objArr = Object.entries(params);
        objArr.forEach((arr) => {
            if (arr[0] == 'mistakeTime') {
                newProps[arr[0]] = {
                    value: arr[1] ? moment(arr[1]) : null,
                };
            } else if (arr[0] == 'mistakeTypeId') {
                newProps[arr[0]] = {
                    value: arr[1] ? String(arr[1]) : undefined,
                };
            } else {
                newProps[arr[0]] = {
                    value: arr[1],
                };
            }
        });
        const mapPropsToFields = () => ({
            ...newProps,
        });
        const CreateForms = Form.create({ mapPropsToFields })(CreateForm);
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}工作失误`}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                confirmLoading={confirmLoading}
                maskClosable={false}
                width={550}
            >
                <div style={{ margin: '10px 0' }}>
                    <CreateForms
                        params={params}
                        isEdit={isEdit}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

export default UpdateWorkError;


// WEBPACK FOOTER //
// ./src/components/user/pmInfo/UpdateWorkError.js